import React, { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import getCornerRules from '../../Services/rulesets';
import PanelCuttingImage from './PanelCuttingImage';
import { translate } from '../../Services/translation';
import { googleAnalyticsProductConfigurator } from '../../Services/googleAnalytics';

const PanelBeamCuttingSvgAlt = ({ id, onClick, items, cutType, shape }) => {
  const articleNumber = useSelector((state) => state.configurator.id);
  const [state, setState] = useState({
    showAngleAerror: false,
    showAngleBerror: false,
    focusAngleA: false,
    focusAngleB: false,
  });
  const [selectedItem, setSelectedItem] = useState(items.find((i) => i.code === cutType.cutCode));

  useEffect(() => {
    if (!cutType.cutCode && items.length > 0) {
      selectBeamType(0);
    } else {
      setSelectedItem(items.find((i) => i.code === cutType.cutCode));
    }
  }, [cutType]);

  const selectBeamType = (index) => {
    if (cutType.cutCode !== items[index].code) {
      onClick('cutAngleA', null);
      onClick('cutAngleB', null);
      onClick('cutCode', items[index].code);
      setSelectedItem(items[index]);
      googleAnalyticsProductConfigurator('selectedBeamType', items[index].type.toString(), articleNumber);
    } else {
      let selectedItem = items[index];
      onClick('cutCode', selectedItem.code);
      setSelectedItem(selectedItem);
    }
  };

  const updateMaxAngleA = (event, isBlur) => {
    setState({ ...state, showAngleAerror: false });
    let { value, min, max } = event.target;
    if (value == '') {
      setState({ ...state, showAngleAerror: true });
    }
    value = Math.max(Number(min), Math.min(Number(max), Number(value)));
    onClick('cutAngleA', value);

    if (isBlur) {
      googleAnalyticsProductConfigurator('cutAngleA', value.toString(), articleNumber);
    }

  };

  const updateMaxAngleB = (event, isBlur) => {
    setState({ ...state, showAngleBerror: false });
    let { value, min, max } = event.target;
    if (value == '') {
      setState({ ...state, showAngleBerror: true });
    }
    value = Math.max(Number(min), Math.min(Number(max), Number(value)));
    onClick('cutAngleB', value);

    if (isBlur) {
      googleAnalyticsProductConfigurator('cutAngleB', value.toString(), articleNumber);
    }
  };

  const getCutAngle = (type, fallback) => {
    let propertyName = `cutAngle${type}`;

    if (!cutType[propertyName] && fallback) {
      return fallback;
    }

    return cutType[propertyName] ? cutType[propertyName] : '';
  };

  const getPlaceHolderValue = (value) => {
    return `0-${value}°`;
  };

  const getIconShapeIcon = (rules) => {
    let left = 0,
      right = 0;

    if (rules.cornerA > 0) {
      switch (rules.cornerA) {
        case 1:
          left = 2;
          break;
        case 4:
          left = 1;
          break;
        case 2:
          right = 2;
          break;
        case 3:
          right = 1;
          break;
      }
    }

    if (rules.cornerB > 0 && right === 0) {
      right = rules.cornerB == 2 ? 2 : 1;
    }

    return `${left}-${right}`;
  };

  const setFocus = (propName, boolValue) => {
    setState({ ...state, [propName]: boolValue, });
  };

  return (
    <Fragment>
      <ul className={'beam-selection ' + (items.length % 2 == 1 ? 'beam-selection--odd' : 'beam-selection--even')}
      >
        {items.length > 0 && items.map((value, index) => (
          <li key={'beam-' + index}>
            <a className={'beam-link' + (selectedItem && selectedItem.code === value.code ? ' beam-link--selected' : '')}
              onClick={(e) => selectBeamType(index)}            >
              <span className='code-number'>{value.code}</span>
              <svg className='cut-icon' viewBox='0 0 360 120'>
                <use
                  href={`/ui/images/sprites/be-cut-shapes.svg#cut-shape-${value.code}-${shape}`}
                ></use>
              </svg>
              <svg className='cut-icon-shape'>
                <use
                  href={`/ui/images/sprites/be-cut-icons.svg#cut-icon-${getIconShapeIcon(getCornerRules(value.code, shape))}`}
                ></use>
              </svg>
            </a>
          </li>
        ))}
      </ul>
      {selectedItem && (
        <div className='beamItems beamItems--full'>
          {cutType && (
            <div className='beam_angle_image'>
              <PanelCuttingImage
                id={id}
                code={selectedItem.code}
                rules={getCornerRules(selectedItem.code, shape)}
                angleA={getCutAngle('A', Math.round(selectedItem.maxAngleA / 2))}
                angleB={getCutAngle('B', Math.round(selectedItem.maxAngleB / 2))}
                focusA={state.focusAngleA}
                focusB={state.focusAngleB}
              ></PanelCuttingImage>
            </div>
          )}
          <div className='cutting_angles'>
            {selectedItem.maxAngleA != -1 && (
              <div className='angle-a'>
                <span>{translate('beamtype.maxanglea')}</span>
                <span className='error'>*</span>
                <span>
                  <input type='number' min='0' max={selectedItem.maxAngleA} placeholder={getPlaceHolderValue(selectedItem.maxAngleA)} value={getCutAngle('A')}
                    onChange={(event) => { updateMaxAngleA(event, false); }} onFocus={() => { setFocus('focusAngleA', true); }}
                    onBlur={(event) => { updateMaxAngleA(event, true); setFocus('focusAngleA', false); }}
                  ></input>
                </span>
              </div>
            )}
            {selectedItem.maxAngleB != -1 && (
              <div className='angle-b'>
                <span> {translate('beamtype.maxangleb')}</span>
                <span className='error'>*</span>
                <input type='number' max={selectedItem.maxAngleB} min='0' placeholder={getPlaceHolderValue(selectedItem.maxAngleB)} value={getCutAngle('B')}
                  onChange={(event) => { updateMaxAngleB(event, false); }} onFocus={() => { setFocus('focusAngleB', true); }}
                  onBlur={(event) => { updateMaxAngleB(event, true); setFocus('focusAngleB', false); }}
                ></input>
              </div>
            )}
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default PanelBeamCuttingSvgAlt;
